import { useController, type Control, type FieldPath, type FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { TextArea } from '@/components/base/textarea/textarea'
import type { ComponentProps } from 'react'

type TextAreaProps = ComponentProps<typeof TextArea>

export interface FormTextareaProps<TFieldValues extends FieldValues>
  extends Omit<TextAreaProps, 'value' | 'onChange' | 'onBlur' | 'hint'> {
  control: Control<TFieldValues>
  name: FieldPath<TFieldValues>
}

export function FormTextarea<TFieldValues extends FieldValues>({
  control,
  name,
  ...props
}: FormTextareaProps<TFieldValues>) {
  const { t } = useTranslation()
  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name,
  })

  return (
    <TextArea
      {...props}
      value={field.value ?? ''}
      onChange={(value) => field.onChange(value)}
      onBlur={field.onBlur}
      hint={error?.message ? t(error.message) : undefined}
      isInvalid={!!error}
    />
  )
}

export default FormTextarea
